export const StaticLinks = {
  notificationCenter: '/my/notification-center'
};
